<template>
  <button
    class="round-button"
    :class="buttonClasses"
  ><slot /></button>
</template>

<script>
export default {
  name: 'RoundButton',
  props: {
    small: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonClasses () {
      return {
        'small': this.small
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.round-button {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 50%;
  display: block;
  background-color: transparent;
  box-shadow: 0 0 25px 3px rgba(white, 0.8);
  transition: all 200ms ease-out;
  cursor: pointer;
  outline: 0;
  border: 2px solid white;

  &:hover {
    background-color: rgba(white, 0.1);
    transform: translate(-50%, -50%) scale(1.05);
  }

  &:active {
    background-color: rgba(white, 0.25);
    transform: translate(-50%, -50%) scale(1);
  }
}

.small {
  transform: translate(-50%, -50%) scale(0.8);
  box-shadow: 0 0 10px 3px rgba(white, 0.2);
  border: 2px solid rgba(white, 0.8);

  &:hover {
    transform: translate(-50%, -50%) scale(0.82);
  }

  &:active {
    transform: translate(-50%, -50%) scale(0.85);
  }
}
</style>
